import { log } from 'next-axiom'
import { Component, ErrorInfo, ReactNode } from 'react'

interface ErrorBoundaryState {
	hasError: boolean
}

class ErrorBoundary extends Component<
	{
		children: ReactNode
	},
	ErrorBoundaryState
> {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}
	static getDerivedStateFromError() {
		return { hasError: true }
	}
	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		try {
			// eslint-disable-next-line no-console
			console.group('[ErrorBoundary] caught a React error')
			// eslint-disable-next-line no-console
			console.error(error)
			// eslint-disable-next-line no-console
			console.error('Name:   ', error?.name)
			// eslint-disable-next-line no-console
			console.error('Message:', error?.message)
			// eslint-disable-next-line no-console
			console.error('Stack:\n' + (error?.stack ?? '(no stack)'))
			// eslint-disable-next-line no-console
			console.error(
				'Component stack:\n' +
					(errorInfo?.componentStack ?? '(no component stack)'),
			)
			// eslint-disable-next-line no-console
			console.error(
				'URL:',
				typeof window !== 'undefined' ? window.location.href : '(SSR)',
			)
			// eslint-disable-next-line no-console
			console.groupEnd()
		} catch {
			// eslint-disable-next-line no-console
			console.error('[ErrorBoundary]', error, errorInfo)
		}

		log.error('ErrorBoundary caught an error', {
			error: {
				name: error?.name,
				message: error?.message,
				stack: error?.stack,
			},
			errorInfo,
			request: {
				host:
					typeof window !== 'undefined'
						? window.location.host || ''
						: '',
				url:
					typeof window !== 'undefined'
						? window.location.href || ''
						: '',
			},
			vercel: {
				deploymentUrl: process.env.NEXT_PUBLIC_VERCEL_URL || '',
			},
		})

		if (process.env.NODE_ENV !== 'development') {
			setTimeout(() => {
				window.location.href = '/?redirectreason=error'
			}, 1000)
		}
	}
	render() {
		if (this.state.hasError) {
			return <></>
		}

		return this.props.children
	}
}

export default ErrorBoundary
